import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { PointTranslationSelectPointButtonVM } from './PointTranslationSelectPointButtonVM';

const setStore = stores.AppStore.surveyEngineeringStore;

export const SelectPointOnMapButton = observer((props) => {
  const vm = useRef(new PointTranslationSelectPointButtonVM(props)).current;
  const thisTypeInSelectMode = `${props.pointType}InSelectMode`;
  return (
    <button
      className={`${
        setStore[thisTypeInSelectMode] ? 'usa-button' : 'usa-button usa-button--outline '
      } translation-map-select-button px-3`}
      onClick={(e) => vm.onClickStartSelectPoint(e)}
    >
      +
    </button>
  );
});
